export const HASH = "7ef92f1";